import * as Types from '../constants/Types';

export const getListCampaigns = (filters) => ({type: Types.CAMPAIGN_LIST_ACTION, filters});
export const dataCampaignSuccess = (campaigns) => ({type: Types.CAMPAIGN_LIST_SUCCESS, campaigns});

export const getCampaignDetail = (id) => ({ type: Types.CAMPAIGN_DETAIL_ACTION, id })
export const setCampaignDetail = (campaign) => ({ type: Types.CAMPAIGN_DETAIL_SUCCESS, campaign });

export const createCampaignDetail = (campaign) => ({ type: Types.CAMPAIGN_CREATE_ACTION, campaign });
export const updateCampaignDetail = (campaign) => ({ type: Types.CAMPAIGN_UPDATE_ACTION, campaign });
export const deleteCampaign = (campaign) => ({ type: Types.CAMPAIGN_DELETE_ACTION, campaign });
export const cloneCampaign = (campaign) => ({ type: Types.CAMPAIGN_CLONE_ACTION, campaign });

export const getCountries = () => ({type: Types.CAMPAIGN_LIST_COUNTRIES_ACTION});
export const getCountriesSuccess = (countries) => ({type: Types.CAMPAIGN_LIST_COUNTRIES_SUCCESS, countries});

export const getChannels = () => ({type: Types.CAMPAIGN_LIST_CHANNEL_ACTION});
export const getChannelsSuccess = (channels) => ({type: Types.CAMPAIGN_LIST_CHANNEL_SUCCESS, channels});

export const createCampaignTranslate = (campaign, promotionExtended, languageCode, languageName) => ({type: Types.CAMPAIGN_CREATE_TRANSLATE_ACTION, campaign, promotionExtended, languageCode, languageName});
export const updateCampaignTranslate = (campaign, promotionExtended, languageCode, languageName) => ({type: Types.CAMPAIGN_UPDATE_TRANSLATE_ACTION, campaign, promotionExtended, languageCode, languageName});
export const deleteCampaignTranslate = (campaign, refreshParams) => ({type: Types.CAMPAIGN_DELETE_TRANSLATE_ACTION, campaign, refreshParams});

export const parseExcel = (file) => ({type: Types.CAMPAIGN_PARSE_EXCEL_ACTION, file});
export const parseExcelSuccess = (file) => ({type: Types.CAMPAIGN_PARSE_EXCEL_SUCCESS, file});
export const parseExcelClearData = () => ({type: Types.CAMPAIGN_PARSE_EXCEL_CLEAR_DATA});

//markup
export const getMarkupPromotionConfig = (filters) => ({type: Types.GET_MARKUP_PROMOTION_CONFIG_ACTION, filters});
export const setMarkupPromotionConfig = (markups) => ({type: Types.GET_MARKUP_PROMOTION_CONFIG_SUCCESS, markups});

export const getMarkupPromotionFly = () => ({type: Types.GET_MARKUP_PROMOTION_FLY_ACTION});
export const setMarkupPromotionFly = (flys) => ({type: Types.GET_MARKUP_PROMOTION_FLY_SUCCESS, flys});

export const getMarkupBundleMinValue = (data) => ({type: Types.GET_MARKUP_BUNDLE_MIN_VALUE_ACTION, data});
export const setMarkupBundleMinValue = (value) => ({type: Types.GET_MARKUP_BUNDLE_MIN_VALUE_SUCCESS, value});

export const getPromotionBanks = () => ({type: Types.CAMPAIGN_LIST_PROMOTION_BANK_ACTION});
export const getPromotionBanksSuccess = (banks) => ({type: Types.CAMPAIGN_LIST_PROMOTION_BANK_SUCCESS, banks});
